/**
 * Procedure Categories and Procedures for DCH and MD in Paediatrics students
 * Extracted with strict evidence from official NMC PDF
 */
export const PAEDIATRICS_PROCEDURES = {
  "Pediatric Diagnostic & Vascular Interventions": [
    "Venous, Capillary and Arterial Blood Sampling",
    "Establishment of Central and Peripheral Vascular Access & CVP Monitoring",
    "Umbilical Artery and Venous Catheterization",
    "Intra-Osseous Fluid Administration & Intra-arterial Cannulation",
    "Lumbar Puncture, Subdural and Ventricular Puncture",
    "Pleural, Peritoneal, Pericardial, and Joint Fluid Diagnostic Taps",
    "Tuberculin Skin Test (Mantoux Test) & Antibiotic Test Dose",
    "Bone Marrow Aspiration & Biopsy",
    "Percutaneous Liver and Kidney Biopsy",
    "Fine Needle Aspiration Cytology (FNAC) of Lymph Node",
    "Urethral Catheterization and Suprapubic Tap",
    "Gastric Content Aspiration & Nasogastric / Ryles Tube Insertion",
  ],
  "Pediatric Resuscitation & Therapeutic Interventions": [
    "Neonatal & Advanced Pediatric Resuscitation (including Endotracheal Intubation)",
    "Heimlich Maneuver & Airway Foreign Body Removal",
    "Neonatal Exchange Transfusion & Blood Component Infusions",
    "Needle Cricothyroidotomy",
    "Non-Invasive Ventilation (HFNC / CPAP) & Mechanical Ventilation",
    "Intercostal Drainage (ICD Tube Insertion)",
    "Surfactant Administration (INSURE Technique)",
    "Therapeutic Ascitic Tap & Peritoneal Dialysis",
    "Phototherapy Administration",
    "Incision and Drainage of Abscess & Common Wound Dressings",
  ],
};

export const PAEDIATRICS_CATEGORIES = Object.keys(PAEDIATRICS_PROCEDURES);

export const isDiplomaInPaediatricsDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (
      d.includes("dch") ||
      d.includes("paediatrics") ||
      d.includes("pediatrics") ||
      d.includes("paediatric") ||
      d.includes("pediatric")
    ) &&
    !d.includes("neurology") &&
    !d.includes("hepatology") &&
    !d.includes("nephrology") &&
    !d.includes("oncology") &&
    !d.includes("surgery")
  );
};
